import { Modal } from '@/ui/Modal'
import { Button } from '@/ui/Button'
import { useModal } from '@/components/Modal'
import { useFlagRecordDone } from '../../api/useFlagRecordDone'

import styles from './MarkAsDoneModal.module.scss'

export type MarkAsDoneModalProps = {
    logId: string
}

export const MarkAsDoneModal = () => {
    const { closeModal, props } = useModal<MarkAsDoneModalProps>()
    const { mutate, isPending } = useFlagRecordDone()

    if (!props) return null

    return (
        <Modal className={styles.modal} onClose={closeModal} hideCloseButton>
            <div className={styles.information}>
                <h1 className={styles.title}>Mark as done</h1>
                <p className={styles.description}>
                    This item will be marked as done and can be reviewed and reopened by a Mileage Clerk. Are you sure
                    you want to mark as done?
                </p>
            </div>
            <div className={styles.footer}>
                <Button rounded variant="tertiary" onClick={closeModal} disabled={isPending}>
                    Cancel
                </Button>
                <Button rounded variant="secondary" onClick={() => mutate(props.logId, { onError: () => closeModal() })} disabled={isPending}>
                    Mark as done
                </Button>
            </div>
        </Modal>
    )
}
